module.exports = __webpack_public_path__ + "img/block-f-2-m.881e5387.jpg";